import React from 'react';
import { motion } from 'framer-motion';

const companies = [
  'Tech Startups',
  'Agencies',
  'E-Commerce Brands',
  'Media Companies',
  'SaaS Platforms',
  'Developers',
];

export const TrustedBy = () => {
  return (
    <section className="py-20 bg-slate-950 border-y border-white/5">
      <div className="max-w-6xl mx-auto px-6 text-center">
        <p className="text-sm uppercase tracking-widest text-slate-400 mb-10">
          Trusted by teams building modern websites
        </p>

        <div className="grid grid-cols-2 md:grid-cols-6 gap-8 items-center">
          {companies.map((company, i) => (
            <motion.div
              key={company}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.08 }}
              viewport={{ once: true }}
              className="text-slate-400 font-semibold text-sm tracking-wide hover:text-white transition"
            >
              {company}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
